import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Bind i18n to React
    .init({
        resources: {
            en: {
                translation: {
                    about: "ABOUT US",
                    contacts: 'CONTACTS',
                    call: 'CALL FOR ADVICE NOW!',
                    say: 'SAY HELLO!',
                    name: 'Name',
                    surname: 'Surname',
                    email: 'Email',
                    phone: 'Phone Number',
                    message: 'Message',
                    send: 'Send us a message',
                    products: 'CATALOG',
                    videos: 'OUR DOWNLOADS',
                    session: 'Seasonality',
                    caliber: 'Calibers',
                    openPdf: 'Open PDF in new tab',
                    downloadPdf: 'Download PDF'
                },
            },
            es: {
                   translation: {
                    about: "Inicio",
                    contacts: 'Contacto',
                    call: '¡LLAMA AHORA PARA ASESORAMIENTO!',
                    say: '¡DI HOLA!',
                    name: 'Nombre',
                    surname: 'Apellido',
                    email: 'Email',
                    phone: 'Telefono',
                    message: 'Asunto',
                    send: 'Enviar asunto',
                    products: 'Catalogo',
                    videos: 'Nuestras cargas',
                    session: 'Estacionalidad',
                    caliber: 'Calibres',
                    openPdf: 'Abrir PDF en nueva pestaña',
                    downloadPdf: 'Descargar PDF'
                },
            },
              ru: {
                   translation: {
                    about: "О НАС",
                    contacts: 'КОНТАКТЫ',
                    call: 'ПОЗВОНИТЕ ЗА КОНСУЛЬТАЦИЕЙ СЕЙЧАС!',
                    say: 'СКАЖИ ПРИВЕТ!',
                    name: 'Имя',
                    surname: 'Фамилия',
                    email: 'Электронная почта',
                    phone: 'Номер телефона',
                    message: 'Сообщение',
                    send: 'Отправьте нам сообщение',
                    products: 'КАТАЛОГ',
                    videos: 'НАШИ ЗАГРУЗКИ',
                    session: 'Сезонность',
                    caliber: 'Калибры',
                    openPdf: 'Открыть PDF в новой вкладке',
                    downloadPdf: 'Скачать PDF'
                },
            },
        },
        fallbackLng: "en", // Default language
        debug: true, // Enable console logs (disable in production)
        interpolation: {
            escapeValue: false, // React handles escaping
        },
    });

export default i18n;
